import React, { Component, Fragment } from 'react'
import gql from 'graphql-tag'
import { Mutation, withApollo } from 'react-apollo'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import Select from '@material-ui/core/Select'
import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import Typography from '@material-ui/core/Typography'
import ClientDetails from '../ClientDetails'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import Dialog from '@material-ui/core/Dialog'
import { withStyles } from '@material-ui/core/styles'
import getLoginId from '../../../../utils/getLoginId'
import ChangeVehicleStatus from './ChangeVehicleStatus'
import DecoupleDevices from './DecoupleDevices'
import withSharedSnackbar from '../../../HOCs/withSharedSnackbar'
import '../vehicle.css'
import DeleteForever from '@material-ui/icons/DeleteForever'
// import SwapHoriz from '@material-ui/icons/SwapHoriz'
import Tooltip from '@material-ui/core/Tooltip'
import SwapClient from './SwapClient'
import DeleteVehicle from './DeleteVehicle'
import CircularProgress from '@material-ui/core/CircularProgress'
import { DatePicker } from 'material-ui-pickers'
import ClearIcon from '@material-ui/icons/Clear'
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Container,
  Switch
} from '@material-ui/core'

import moment from 'moment'

const GET_VLPN = gql`
  query checkVehicleNumber($vlpn: String!) {
    checkVehicleNumber(vehicleNumber: $vlpn)
  }
` /* eslint-disable */
// calling server for updation
const UPDATE_VEHICLE = gql`
  mutation updateVehicleDetail(
    $entityId: Int!
    $vehicleNumber: String!
    $engineNumber: String
    $chassisNumber: String
    $clientLoginId: Int!
    $speedSensorType: String!
    $speedLimit: Int!
    $vehicleType: String!
    $vehcleModel: String!
    $vehicleCapacity: Int
    $equipmentSerialNumber: String
    $equipmentName: String
    $commissioningDate: Int
    $department: String
    $idlingSpeed: Int
    $invoiceNumber: String
    $isActivated: Boolean
    $status: Int!
    $contractorName: String
    $phoneIMEI: String
     $vinNumber: String

    $truckBrandId: Int
    $truckModelId: Int
  ) {
    updateVehicleDetail(
      entityId: $entityId
      vehicleNumber: $vehicleNumber
      engineNumber: $engineNumber
      chassisNumber: $chassisNumber
      clientLoginId: $clientLoginId
      speedSensorType: $speedSensorType
      speedLimit: $speedLimit
      vehicleType: $vehicleType
      vehicleModel: $vehcleModel
      vehicleCapacity: $vehicleCapacity
      equipmentSerialNumber: $equipmentSerialNumber
      equipmentName: $equipmentName
      commissioningDate: $commissioningDate
      department: $department
      idlingSpeed: $idlingSpeed
      invoiceNumber: $invoiceNumber
      isActivated: $isActivated
      status: $status
      contractorName: $contractorName
      phoneIMEI: $phoneIMEI
      vinNumber: $vinNumber
      truckBrandId: $truckBrandId
      truckModelId: $truckModelId
    )
  }
`

const GET_VEHICLE_DETAIL = gql`
  query getVehicleDetail($entityId: Int) {
    getVehicleDetail(entityId: $entityId) {
      vehicleNumber
      speedSensorType
      speedLimit
      vehicleType
      vehicleModel

      vehicleCapacity
      engineNumber
      chassisNumber
      status
      equipmentSerialNumber
      commissioningDate
      invoiceNumber
      idlingSpeed
      department
      contractorName
      equipmentName
      certificatePath
      phoneIMEI
      truck_model_id {
        id
        name
        cum_weight
        client_login_id
        truck_brand_id
        created_at
        updated_at
      }
      truck_brand_id {
        id
        name
        client_login_id
        created_at
        updated_at
      }
      client {
        clientName
        contactPerson
        address
        city
        email
        contactNumber
        loginId
      }
      device {
        vehicleDetail {
            vinNumber
        }
        serial_num
        imei_num
        uniqueDeviceId
        deviceModelId {
          model_name
          devicetype
        }
      }
      sim {
        id
        phoneNumber
        simNumber
        serviceProvider {
          name
        }
      }
    }
  }
`
const GENERATE_CERTIFICATE = gql`
  query generatePDF($entityId: Int!) {
    generatePDF(entityId: $entityId) {
      bucketName
      filename
      filePublicDownloadURL
    }
  }
`

const GET_BRANDS = gql`
  query GetBrands($clientLoginId: Int!) {
    getBrands(clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
        client_login_id
        created_at
        updated_at
      }
    }
  }
`
export const GET_MODELS_BY_BRAND = gql`
  query GetModelsByBrand($brandId: Int!, $clientLoginId: Int!) {
    getModelsByBrand(brandId: $brandId, clientLoginId: $clientLoginId) {
      status
      message
      data {
        id
        name
        cum_weight
        client_login_id
        truck_brand_id
        created_at
        updated_at
      }
    }
  }
`
const SEND_MAIL = gql`
  query sendVehicleCertificate($email: String, $pdfLink: String) {
    sendVehicleCertificate(email: $email, pdfLink: $pdfLink)
  }
`
// const DOWNLOAD_FILE = gql`
//   query getMinioFileURL($bucketName: String!, $fileName: String!) {
//     getMinioFileURL(bucketName: $bucketName, fileName: $fileName) {
//       url
//     }
//   }
// `
// const UPDATE_VEHICLE_STATUS = gql`
//   mutation addDeviceService(
//     $uniqueDeviceId: String!
//     $isActivated: Boolean!
//   ) {
//     addDeviceService(
//       uniqueDeviceId: $uniqueDeviceId
//       isActivated: $isActivated
//     )
//   }
// `

const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4,
    flexGrow: 1
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '200px'
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  iconSmall: {
    fontSize: 20
  }
})

class VehicleRegistration extends Component {
  constructor(props) {
    super(props)
    this.entityId = this.props.match.params.entityId

    this.state = {
      /* eslint-disable */

      isSpeedLimitValid: true,
      isSeatLimitValid: true,
      speedLimit: '',
      serialNumber: '',
      partnerLoginId: getLoginId(),
      // partnerLoginId: 8,
      isSerialNumberValid: true,
      modelName: '',
      deviceType: '',
      status: 1,
      phoneNumber: '',
      isPhoneNoValid: true,
      simProvider: '',
      simNumber: '',
      vlpn: '',
      isVlpnValid: true,
      vehicleModel: '',
      vinNumber: '',
      isVehicleModelValid: true,
      clientName: '',
      isClientNameValid: true,
      vehicleType: '',
      isVehicleTypeValid: true,
      truckModelId: '',
      brandsDetails: '',
      modelsDetails: '',
      truckBrandId: '',
      speedSensor: '',
      isSpeedSensorValid: true,
      accessories: null,
      clientsDetails: [],
      deviceDetails: [],
      simDetails: [],
      accessoryDetails: [],
      response: false,
      failure: false,
      schoolBusEnable: false,
      clientLoginId: '',
      installStatus: false,
      open: false,
      open2: false,
      truckBrand: '',
      truckModel: '',
      simId: '',
      engineNumber: '',
      chassisNumber: '',
      seatLimit: '',
      swapOpen: false,
      deleteOpen: false,
      fileResponse: '',
      fileName: '',
      uploadError: '',
      idlingSpeed: 3,
      invoiceNumber: '',
      equipmentSerialNumber: '',
      equipmentName: '',
      commissioningDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      },
      department: '',
      contractorName: '',
      PDFLink: '',
      open3: false,
      mail: '',
      ismailValid: true,
      phoneIMEI: '',
      addPhoneDetails: false
    }

    if (this.props.location.state) {
      this.setState({ clientName: this.props.location.state.clientId })
    } else {
      this.setState({ clientName: '' })
    }
  }

  clearDate = () => {
    this.setState({
      commissioningDate: {
        date: null,
        unix: moment()
          .unix()
          .toString()
      }
    })
  }
  handleChangeIdlingSpeed = event => {
    if (event) {
      this.setState({ idlingSpeed: event.target.value })
    } else {
      this.setState({ idlingSpeed: 3 })
    }
  }
  handleDateChange = name => date => {
    let tempDate = this.state[name]
    tempDate.date = date
    tempDate.unix = moment(date)
      .unix()
      .toString()
    this.setState({ [name]: tempDate })
  }
  getVehicleDetails = async () => {
    console.log(this.entityId)
    const { data } = await this.props.client.query({
      query: GET_VEHICLE_DETAIL,
      variables: {
        entityId: parseInt(this.entityId, 10)
      },
      fetchPolicy: 'network-only'
    })
    console.log("reponse data: ", data);
    this.setDetails(data.getVehicleDetail)
    console.log("this.state: ", data.getVehicleDetail);
    if (data.getVehicleDetail.truck_brand_id) {
      this.getAllBrands(
        data.getVehicleDetail.client.loginId,
        data.getVehicleDetail.truck_model_id.id,
        data.getVehicleDetail.truck_brand_id.id
      )
    }
    console.log('')
    // this.getAllBrands(this.state.clientLoginId, null, null)
    this.getAllBrands(this.state.clientLoginId, null, null)
  }
  getFormattedDate = timestamp => {
    console.log(timestamp, 'here')
    return moment(timestamp * 1000).format('MMM Do YYYY, h:mm a')
  }

  setDetails = vehicleDetail => {
    let commissioningDate = {
      date: null,
      unix: moment().unix()
    }
    if (vehicleDetail.commissioningDate) {
      commissioningDate = {
        date: moment.unix(vehicleDetail.commissioningDate).format('YYYY-MM-DD'),
        unix: vehicleDetail.commissioningDate
      }
    }

    const vinNumber = vehicleDetail.device &&
      vehicleDetail.device.vehicleDetail &&
      vehicleDetail.device.vehicleDetail.vinNumber || '';

    console.log("Setting VIN Number:", vinNumber); 

    this.setState({
      address: vehicleDetail.client.address,
      city: vehicleDetail.client.city,
      clientName: vehicleDetail.client.clientName,
      contactPerson: vehicleDetail.client.contactPerson,
      email: vehicleDetail.client.email,
      contactNumber: vehicleDetail.client.contactNumber,
      vlpn: vehicleDetail.vehicleNumber,
      speedSensor: vehicleDetail.speedSensorType,
      speedLimit: vehicleDetail.speedLimit,
      vehicleType: vehicleDetail.vehicleType,
      vehicleModel: vehicleDetail.vehicleModel,
      vinNumber: vinNumber, // CORRECTED to use the properly extracted vinNumber
      vehicleCapacity: vehicleDetail.vehicleCapacity,
      status: vehicleDetail.status,
      serialNumber: vehicleDetail.device.serial_num,
      modelName: vehicleDetail.device.deviceModelId.model_name,
      deviceType: vehicleDetail.device.deviceModelId.devicetype,
      phoneNumber: vehicleDetail.sim.phoneNumber,
      simProvider: vehicleDetail.sim.serviceProvider.name,
      simNumber: vehicleDetail.sim.simNumber,
      uniqueDeviceId: vehicleDetail.device.uniqueDeviceId,
      clientLoginId: vehicleDetail.client.loginId,
      engineNumber: vehicleDetail.engineNumber,
      chassisNumber: vehicleDetail.chassisNumber,
      simId: vehicleDetail.sim.id,

      equipmentSerialNumber: vehicleDetail.equipmentSerialNumber
        ? vehicleDetail.equipmentSerialNumber
        : null,
      commissioningDate: commissioningDate,
      invoiceNumber: vehicleDetail.invoiceNumber
        ? vehicleDetail.invoiceNumber
        : null,
      idlingSpeed: vehicleDetail.idlingSpeed,
      department: vehicleDetail.department ? vehicleDetail.department : '',
      equipmentName: vehicleDetail.equipmentName
        ? vehicleDetail.equipmentName
        : null,
      contractorName: vehicleDetail.contractorName
        ? vehicleDetail.contractorName
        : '',
      phoneIMEI: vehicleDetail.phoneIMEI,
      addPhoneDetails:
        vehicleDetail.phoneIMEI && vehicleDetail.phoneIMEI.length ? true : false
    })

    if (vehicleDetail.certificatePath) {
      let x = vehicleDetail.certificatePath.split('/')
      let len = x.length
      console.log(x[len - 1])
      this.setState({ fileName: x[len - 1] })
    }

    console.log(this.state.vehicleType, 'typ')
    if (vehicleDetail.status !== 2) {
      this.setState({ installStatus: true })
    }
    if (this.state.vehicleCapacity !== null) {
      this.setState({
        isSeatLimitValid: true,
        seatLimit: this.state.vehicleCapacity
      })
    } else {
      this.setState({
        seatLimit: null
      })
    }
    console.log('seat', this.state.seatLimit, this.state.installStatus)
  }
  handleInputChange = key => e => {
    this.setState({ [key]: e.target.value })
  }

  handleChangeType = event => {
    const selectedVehicleType = event.target.value
    this.setState(prevState => ({
      vehicleType: selectedVehicleType, // Update the vehicle type
      truckBrand: selectedVehicleType === 'Truck' ? prevState.truckBrand : '', // Keep as is if "Truck", else reset
      truckModel: selectedVehicleType === 'Truck' ? prevState.truckModel : '' // Keep as is if "Truck", else reset
    }))
    this.getAllBrands(this.state.clientLoginId, null, null)
  }

  handleChangeSpeedSensor = event => {
    this.setState({ speedSensor: event.target.value })
  }
  handleMailChange = event => {
    this.setState({ mail: event.target.value })
  }
  checkMail = () => {
    const regex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
    this.setState({
      ismailValid: regex.test(this.state.mail) && this.state.mail !== ''
    })
  }
  checkVehicleModelValidity = () => {
    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/)
    this.setState({
      isVehicleModelValid:
        regex.test(this.state.vehicleModel) &&
        this.state.vehicleModel !== '' &&
        this.state.vehicleModel.length > 1 &&
        this.state.vehicleModel.length < 21
    })
  }
  checkSpeedLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]{0,2}$/)
    this.setState({
      isSpeedLimitValid:
        regex.test(this.state.speedLimit) &&
        this.state.speedLimit !== '' &&
        this.state.speedLimit <= 160
    })
  }
  checkSeatLimitValidity = () => {
    const regex = new RegExp(/^[1-9][0-9]$/)
    this.setState({
      isSeatLimitValid:
        regex.test(this.state.seatLimit) && this.state.seatLimit !== ''
    })
  }
  checkVlpnValidity = client => async event => {
    await client.query({
      query: GET_VLPN,
      variables: { vlpn: this.state.vlpn }
    })

    this.setState({
      isVlpnValid:
        this.state.vlpn !== '' &&
        this.state.vlpn.length > 4 &&
        this.state.vlpn.length < 33
    })
  }

  checkVehicleTypeValidity = () => {
    this.setState({
      isVehicleTypeValid: this.state.vehicleType !== ''
    })
    if (this.state.vehicleType === 'school bus') {
      this.setState({
        isseatLimitValid: true
      })
    } else {
      this.setState({
        isseatLimitValid: false
      })
    }

    // console.log('vehicle type', this.state.vehicleType)
  }
  checkSpeedSensorValidity = () => {
    this.setState({
      isSpeedSensorValid: this.state.speedSensor !== ''
    })
  }

  handleSubmit = client => async event => {
    console.log('click fun', this.state.installStatus)
    console.log(this.state.truckBrand, this.state.truckModel)
    if (this.state.seatLimit === '') {
      this.setState({ seatLimit: null })
    }
    event.preventDefault()
    let installationStatus
    if (this.state.installStatus && this.state.status === 2) {
      installationStatus = 1
    } else {
      installationStatus = this.state.status
    }
    if (this.state.engineNumber === '') {
      this.setState({ engineNumber: null })
    }
    if (this.state.chassisNumber === '') {
      this.setState({ chassisNumber: null })
    }
    // console.log('last', this.state.installStatus, installationStatus)
    let commissioningDate =
      this.state.commissioningDate.date === null
        ? null
        : parseInt(this.state.commissioningDate.unix)
    console.log("hello", this.state.vinNumber);


    const { data, errors } = await client.mutate({
      mutation: UPDATE_VEHICLE,
      variables: {
        vehicleNumber: this.state.vlpn,
        entityId: parseInt(this.entityId, 10),
        clientLoginId: parseInt(this.state.clientLoginId, 10),
        speedSensorType: this.state.speedSensor,
        speedLimit: parseInt(this.state.speedLimit, 10),
        vinNumber: this.state.vinNumber ? this.state.vinNumber : null,
        vehicleType: this.getVehicleType(this.state.vehicleType),
        vehcleModel: this.state.vehicleModel,
        truckModelId:
          this.state.truckModel === '' ||
            this.state.truckModel === ' ' ||
            this.state.truckModel === null ||
            this.state.truckModel === NaN
            ? null
            : parseInt(this.state.truckModel),
        truckBrandId: parseInt(this.state.truckBrand),
        vehicleCapacity: parseInt(this.state.seatLimit, 10),
        isActivated: this.state.installStatus,
        status: parseInt(installationStatus, 10),
        engineNumber: this.state.engineNumber,
        chassisNumber: this.state.chassisNumber,
        equipmentSerialNumber: this.state.equipmentSerialNumber,
        commissioningDate: commissioningDate,
        idlingSpeed: this.state.idlingSpeed,
        equipmentName: this.state.equipmentName,
        invoiceNumber: this.state.invoiceNumber,
        department: this.state.department,
        contractorName: this.state.contractorName,
        phoneIMEI: this.state.addPhoneDetails ? this.state.phoneIMEI : ''
      },
      errorPolicy: 'all'
    })

    if (data) {
      this.setState({ response: data.addVehicleDetail })
      this.props.openSnackbar('Vehicle Details Updated Successfully')
      this.props.history.goBack()
    } else {
      this.setState({ failure: true })
      this.props.openSnackbar(errors[0].message)
    }
    // console.log('fail', this.state.failure)
  }

  getAllBrands = async (id, truckModelId, brandId) => {
    console.log('hihu', id, brandId)
    try {
      const brandsDetails = await this.props.client.query({
        query: GET_BRANDS,
        variables: {
          clientLoginId: parseInt(id, 10)
        },
        fetchPolicy: 'network-only'
      })

      const allBrands = brandsDetails.data.getBrands.data.map(brand => ({
        value: brand.id,
        label: brand.name
      }))
      console.log('gg', allBrands)
      this.setState({ brandsDetails: allBrands }, () => {
        // Preselect the brand after fetching the brands list
        console.log('updated', this.state.brandsDetails)
        if (brandId) {
          const selectedBrand = allBrands.find(brand => brand.value === brandId)
          if (selectedBrand) {
            console.log('Preselected brand:', selectedBrand)
            this.setState({ truckBrand: selectedBrand.value }, () => {
              console.log('Updated state truckBrand:', this.state.truckBrand)

              // Fetch models for the selected brand
              if (truckModelId) {
                this.getModelsByBrand(id, truckModelId, brandId)
              }
            })
          }
        }
      })
    } catch (error) {
      console.error('Error fetching brands:', error)
      // Optionally handle error (e.g., set an error state)
    }
  }

  getModelsByBrand = async (id, truckModelId, brandId) => {
    console.log(id, truckModelId, brandId)
    try {
      console.log(
        'Fetching models for brandId:',
        brandId,
        'and clientLoginId:',
        this.state.clientName
      )

      const modelsDetails = await this.props.client.query({
        query: GET_MODELS_BY_BRAND,
        variables: {
          brandId: parseInt(brandId, 10),
          clientLoginId: parseInt(id ? id : this.state.clientName, 10)
        },
        fetchPolicy: 'network-only'
      })

      const allModels = modelsDetails.data.getModelsByBrand.data.map(model => ({
        value: model.id,
        label: model.name,
        cumWeight: model.cum_weight,
        clientLoginId: model.client_login_id,
        truckBrandId: model.truck_brand_id,
        createdAt: model.created_at,
        updatedAt: model.updated_at
      }))

      this.setState({ modelsDetails: allModels }, () => {
        // Preselect the model after fetching the models list
        console.log('Updated modelsDetails:', this.state.modelsDetails)
        const selectedModel = allModels.find(
          model => model.value === truckModelId
        )
        if (selectedModel) {
          console.log('Preselected model:', selectedModel)
          this.setState({ truckModel: selectedModel.value }, () => {
            console.log('Updated state truckModel:', this.state.truckModel)
          })
        }
      })

      console.log('Fetched models:', allModels)
    } catch (error) {
      console.error('Error fetching models by brand:', error)
      // Optionally handle error (e.g., set an error state)
      this.setState({ modelsDetails: [] }) // Reset state in case of error
    }
  }

  handleChange = name => event => {
    console.log(this.state.installStatus, 'inst')
    this.setState(
      { [name]: event.target.checked, installStatus: event.target.checked },
      () => {
        console.log('int', this.state.installStatus)
      }
    )
    // console.log(this.state.installStatus, 'inst')
  }
  componentDidMount() {
    // console.log('hello')
    this.getVehicleDetails()

    // this.handleClickOpen()
  }

  handleClickOpen = () => {
    this.setState({ open: true })
  }
  handleClose = status => {
    this.setState({ open: false })
  }
  handleDecoupleOpen = () => {
    this.setState({ open2: true })
  }
  handleDecoupleClose = () => {
    this.setState({ open2: false })
  }

  handleMailClose = () => {
    this.setState({
      open3: false,
      ismailValid: true,
      mail: ''
    })
  }
  handleSwapClose = () => {
    this.setState({ swapOpen: false })
  }
  handleDeleteClose = () => {
    this.setState({ deleteOpen: false })
  }
  handleSucessDeleteClose = () => {
    this.setState({ deleteOpen: false })
    this.props.history.push({
      pathname: '/home/VehcileDashboard/Dashboard'
    })
  }

  swapClient = () => {
    this.setState({ swapOpen: true })
  }
  deleteVehicle = () => {
    this.setState({ deleteOpen: true })
  }

  // Activate deactivate function
  // handleClickButtonAction = client => async currentStatus => {
  //   let updateStatus
  //   if (currentStatus === 0) {
  //     updateStatus = true
  //   } else {
  //     updateStatus = false
  //   }
  //   const { data, Error } = await client.mutate({
  //     mutation: UPDATE_VEHICLE_STATUS,
  //     variables: {
  //       uniqueDeviceId: this.state.uniqueDeviceId,
  //       isActivated: updateStatus
  //     },
  //     errorPolicy: 'all'
  //   })
  //   this.setState({
  //     currentStatus: ''
  //   })
  // }

  // onUpload = async ({
  //   target: {
  //     validity,
  //     files: [file]
  //   }
  // }) => {
  //   /* eslint-disable */

  //   // TODO: Handle upload errors
  //   this.setState({ isUploading: true })
  //   if (validity.valid) {
  //     this.setState({ fileName: file.name })
  //     var formdata = new FormData()
  //     formdata.append('certificateFile', file, file.name)
  //     formdata.append('vehicleNumber', this.state.vlpn)

  //     var requestOptions = {
  //       method: 'POST',
  //       body: formdata,
  //       redirect: 'follow'
  //     }

  //     fetch(process.env.REACT_APP_FILE_UPLOAD_URL, requestOptions)
  //       .then(response => response.text())
  //       .then(result => this.setState({ fileResponse: result }))
  //       .catch(error => this.setState({ uploadError: error }))
  //   }
  //   this.setState({ isUploading: false })
  // }

  // Todo function for generate PDF
  handleGenerate = async event => {
    const { data } = await this.props.client.query({
      query: GENERATE_CERTIFICATE,
      variables: {
        entityId: parseInt(this.entityId, 10)
      },
      fetchPolicy: 'network-only'
    })

    if (data.generatePDF) {
      this.setState({ PDFLink: data.generatePDF.filePublicDownloadURL })

      this.setState({ open3: true })
    } else {
      this.props.openSnackbar('Error in generating Certificate')
    }

    // console.log('DATA', data)
    // console.log('PDFlink', this.state.PDFLink)
  }

  handleChangeBrand = selectedBrand => {
    if (selectedBrand) {
      console.log('Selected Brand:', selectedBrand)
      this.setState(
        { truckBrand: selectedBrand.value }, // Update state with selected brand
        () => {
          // Fetch models after state update
          this.getModelsByBrand(
            this.state.clientLoginId,
            null,
            this.state.truckBrand
          )
        }
      )
    } else {
      console.log('Brand selection cleared')
      this.setState({
        truckBrand: null, // Clear the brand selection
        modelsDetails: [], // Clear models if brand is cleared
        truckModel: null // Clear the selected model
      })
    }
  }

  handleSendMail = async event => {
    const responce = await this.props.client.query({
      query: SEND_MAIL,
      variables: {
        email: this.state.mail,
        pdfLink: this.state.PDFLink
      },
      fetchPolicy: 'network-only'
    })
    if (responce.data) {
      this.setState({
        open3: false,
        ismailValid: true,
        mail: ''
      })
      this.props.openSnackbar('Link Sent to email Address')
    } else {
      this.props.openSnackbar(responce.error)
    }
  }

  downloadCertificate = async event => {
    const { data } = await this.props.client.query({
      query: GENERATE_CERTIFICATE,
      variables: {
        entityId: parseInt(this.entityId, 10)
      },
      fetchPolicy: 'network-only'
    })
    if (data.generatePDF) {
      this.setState({ PDFLink: data.generatePDF.filePublicDownloadURL })
      let link = document.createElement('a')
      link.href = this.state.PDFLink
      link.click()
      URL.revokeObjectURL(link.href)
    } else {
      this.props.openSnackbar('Error in Downloading Certificate')
    }
  }

  getVehicleType = val => {
    const vehicleMap = {
      'School Bus': 'SchoolBus',
      '3-Wheeler': 'ThreeWheeler',
      PremiumBuggy: 'PremiumBuggy'
    }

    return vehicleMap[val] || val
  }

  render() {
    const classes = this.props
    let allIdlingSpeed = [
      {
        value: 0,
        label: 0
      },
      {
        value: 1,
        label: 1
      },
      {
        value: 2,
        label: 2
      },
      {
        value: 3,
        label: 3
      }
    ]
    return (
      <div className={classes.root}>
        <div style={{ float: 'left' }}>
          <Button
            variant="outlined"
            color="secondary"
            className={classes.button}
            // href="/home/customers"
            // onClick={() => this.allCustomer(this.backUrl)}
            onClick={() => this.props.history.goBack()}
          >
            <Tooltip title="Go back to Previous page">
              <ArrowBackIcon className={classes.iconSmall} />
            </Tooltip>
          </Button>{' '}
          <Button
            variant="outlined"
            color="secondary"
            className={classes.button}
            // href="/home/customers"
            // onClick={() => this.allCustomer(this.backUrl)}
            onClick={this.deleteVehicle}
          >
            <Tooltip title="Delete Vehicle">
              <DeleteForever className={classes.icon} />
            </Tooltip>
          </Button>{' '}
          {/* <Button
            variant="outlined"
            color="secondary"
            className={classes.button}
            onClick={this.swapClient}
          >
            <Tooltip title="Assign Device to other client">
              <SwapHoriz className={classes.icon} />
            </Tooltip>
          </Button> */}
        </div>
        <Grid
          container
          justify="center"
          className="full-screen"
          alignItems="flex-end"
        >
          <Grid item xs={12}>
            {/* <ItemCard className="form_layout"> */}
            <h3 className="Formheader">Edit Vehicle Detail</h3>
            <Typography
              variant="subheading"
              gutterBottom
              style={{
                color: 'red',
                marginLeft: '25px'
              }}
            >
              {this.state.failure && <span>Updation Failed</span>}
            </Typography>
            <Typography
              variant="subheading"
              gutterBottom
              style={{
                color: 'green',
                marginLeft: '25px'
              }}
            >
              {this.state.response && (
                <p>Vehicle Details Updated Sucessfully</p>
              )}
            </Typography>
            <form>
              <div className="formouter">
                <Grid container>
                  <Grid container className="searchdiv">
                    <ClientDetails
                      clientName={this.state.clientName}
                      address={this.state.address}
                      city={this.state.city}
                    />
                  </Grid>
                  <Grid
                    container
                    style={{
                      marginTop: '20px'
                    }}
                  >
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12} sm={12}>
                        Vehicle Info:
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="vlpn"
                              name="vlpn"
                              className="textfield"
                              margin="dense"
                              label="Vehicle Number"
                              // type="Multi-line"
                              value={this.state.vlpn}
                              required
                              onChange={this.handleInputChange('vlpn')}
                              error={!this.state.isVlpnValid}
                              onBlur={this.checkVlpnValidity(this.props.client)}
                            />

                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isVlpnValid
                                ? 'Invalid Vehicle Number'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>{' '}
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="engineNumber"
                              name="engineNumber"
                              className="textfield"
                              margin="dense"
                              label="Engine Number"
                              // type="Multi-line"
                              value={this.state.engineNumber}
                              onChange={this.handleInputChange('engineNumber')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>{' '}
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="chassisNumber"
                              name="chassisNumber"
                              className="textfield"
                              margin="dense"
                              label="Chassis Number"
                              // type="Multi-line"
                              value={this.state.chassisNumber}
                              onChange={this.handleInputChange('chassisNumber')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>{' '}
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <InputLabel htmlFor="selectLabel">
                              Select Speed Sensor
                            </InputLabel>
                            <Select
                              value={this.state.speedSensor}
                              onChange={this.handleChangeSpeedSensor}
                              name="Speed Sensor Type"
                              label="Speed Sensor Type"
                              error={!this.state.isSpeedSensorValid}
                              onBlur={this.checkSpeedSensorValidity}
                              input={
                                <Input name="speedSensor" id="age-helper" />
                              }
                            >
                              <MenuItem value={'GPS SPEED SENSOR'}>
                                Gps Speed Sensor
                              </MenuItem>
                              <MenuItem value={'DELTA_DISTANCE_CALCULATION'}>
                                Delta Distance
                              </MenuItem>
                              <MenuItem value={'ODOMETRIC'}>Odometric</MenuItem>
                            </Select>
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedSensorValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="speedLimit"
                              name="speedLimit"
                              className="textfield"
                              margin="dense"
                              label="Speed Limit"
                              type="text"
                              // type="Multi-line"
                              value={this.state.speedLimit}
                              required
                              onChange={this.handleInputChange('speedLimit')}
                              error={!this.state.isSpeedLimitValid}
                              onBlur={this.checkSpeedLimitValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isSpeedLimitValid
                                ? 'Invalid Speed Limit'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="vehicleModel"
                              name="vehicleModel"
                              className="textfield"
                              margin="dense"
                              label="Vehicle Model"
                              // type="Multi-line"
                              value={this.state.vehicleModel}
                              required
                              onChange={this.handleInputChange('vehicleModel')}
                              error={!this.state.isVehicleModelValid}
                              onBlur={this.checkVehicleModelValidity}
                            />
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isVehicleModelValid
                                ? 'Invalid Vehicle Model'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="vinNumber"
                              name="vinNumber"
                              className="textfield"
                              margin="dense"
                              label="VIN Number"
                              // type="Multi-line"
                              value={this.state.vinNumber || ''}
                            
                              onChange={this.handleInputChange('vinNumber')}
                            // error={!this.state.isVehicleModelValid}
                            // onBlur={this.checkVehicleModelValidity}
                            />

                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="invoiceNumber"
                              name="invoiceNumber"
                              className="textfield"
                              margin="dense"
                              label="Invoice Number"
                              type="text"
                              // type="Multi-line"
                              value={this.state.invoiceNumber}
                              onChange={this.handleInputChange('invoiceNumber')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <InputLabel htmlFor="selectLabel">
                              Select idling Speed
                            </InputLabel>
                            <Select
                              value={this.state.idlingSpeed}
                              onChange={this.handleChangeIdlingSpeed}
                              name="Select Idling Speed"
                              label="Select Idling Speed"
                              input={
                                <Input name="idlingSpeed" id="age-helper" />
                              }
                            >
                              <MenuItem value={0}>0</MenuItem>
                              <MenuItem value={1}>1</MenuItem>
                              <MenuItem value={2}>2</MenuItem>
                              <MenuItem value={3}>3</MenuItem>
                            </Select>
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="equipmentSerialNumber"
                              name="equipmentSerialNumber"
                              className="textfield"
                              margin="dense"
                              label="Equipment Serial Number"
                              type="text"
                              // type="Multi-line"
                              value={this.state.equipmentSerialNumber}
                              onChange={this.handleInputChange(
                                'equipmentSerialNumber'
                              )}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="equipmentName"
                              name="equipmentName"
                              className="textfield"
                              margin="dense"
                              label="Equipment Name"
                              type="text"
                              // type="Multi-line"
                              value={this.state.equipmentName}
                              onChange={this.handleInputChange('equipmentName')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid container item xs={12} sm={12} fullwidth="true">
                        <DatePicker
                          format="DD/MM/YYYY"
                          maxDate={new Date()}
                          value={this.state.commissioningDate.date}
                          onChange={this.handleDateChange('commissioningDate')}
                          label="Commissioning Date"
                        />
                        <IconButton
                          // style={{ padding: 0 }}
                          edge="end"
                          size="small"
                          onClick={() => this.clearDate()}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Grid>
                      {/* <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="vtsSerialNumber"
                              name="vtsSerialNumber"
                              className="textfield"
                              margin="dense"
                              label="VTS Serial Number"
                              type="text"
                              // type="Multi-line"
                              value={this.state.vtsSerialNumber}
                              onChange={this.handleInputChange(
                                'vtsSerialNumber'
                              )}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid> */}
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="department"
                              name="department"
                              className="textfield"
                              margin="dense"
                              label="Department"
                              type="text"
                              // type="Multi-line"
                              value={this.state.department}
                              onChange={this.handleInputChange('department')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="contractorName"
                              name="contractorName"
                              className="textfield"
                              margin="dense"
                              label="Contractor Name"
                              type="text"
                              // type="Multi-line"
                              value={this.state.contractorName}
                              onChange={this.handleInputChange(
                                'contractorName'
                              )}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <InputLabel htmlFor="selectLabel">
                              Select Vehicle Type
                            </InputLabel>
                            <Select
                              value={this.getVehicleType(
                                this.state.vehicleType
                              )}
                              onChange={this.handleChangeType}
                              error={!this.state.isVehicleTypeValid}
                              onBlur={this.checkVehicleTypeValidity}
                              name="Select Client"
                              // label="Select Vehicle Type"
                              input={
                                <Input name="vehicleType" id="age-helper" />
                              }
                            >
                              <MenuItem value="">
                                <em>None</em>
                              </MenuItem>
                              <MenuItem value="Bike">Bike</MenuItem>
                              <MenuItem value="Car">Car</MenuItem>
                              <MenuItem value="Truck">Truck</MenuItem>
                              <MenuItem value="Ambulance">Ambulance</MenuItem>
                              <MenuItem value="SchoolBus">School Bus</MenuItem>
                              <MenuItem value="Sixseater">Sixseater</MenuItem>
                              <MenuItem value="Stacker">Stacker</MenuItem>
                              <MenuItem value="Tow">Tow</MenuItem>
                              <MenuItem value="Tug">Tug</MenuItem>
                              <MenuItem value="Bike">Bike</MenuItem>
                              <MenuItem value="Tractor">Tractor</MenuItem>
                              <MenuItem value="Excavator">Excavator</MenuItem>
                              <MenuItem value="ThreeWheeler">
                                3-Wheeler
                              </MenuItem>
                              <MenuItem value="PremiumBuggy">
                                Premium Buggy
                              </MenuItem>
                              <MenuItem value="GeneratorTanker">
                                GeneratorTanker
                              </MenuItem>
                            </Select>
                            <FormHelperText
                              id="name-error-text"
                              className="Error_msg"
                            >
                              {!this.state.isClientNameValid
                                ? 'Invalid Selection'
                                : ''}
                            </FormHelperText>
                          </FormGroup>
                        </FormControl>
                      </Grid>{' '}
                      {this.state.vehicleType === 'Truck' ? (
                        <div>
                          <Grid item xs={12} sm={12}>
                            <FormControl className="selectbox">
                              <FormGroup className="form-input">
                                <InputLabel htmlFor="selectLabel">
                                  Select Truck Brand
                                </InputLabel>
                                <Select
                                  classes={classes}
                                  labelId="brand-select-label"
                                  value={
                                    this.state.brandsDetails.length > 0
                                      ? this.state.truckBrand
                                      : ''
                                  }
                                  onChange={event =>
                                    this.handleChangeBrand(
                                      this.state.brandsDetails.find(
                                        brand =>
                                          brand.value === event.target.value
                                      )
                                    )
                                  }
                                  displayEmpty
                                >
                                  {this.state.brandsDetails.length > 0 ? (
                                    this.state.brandsDetails.map(brand => (
                                      <MenuItem
                                        key={brand.value}
                                        value={brand.value}
                                      >
                                        {brand.label}
                                      </MenuItem>
                                    ))
                                  ) : (
                                    <MenuItem disabled>
                                      No options available
                                    </MenuItem>
                                  )}
                                </Select>

                                <FormHelperText
                                  id="name-error-text"
                                  className="Error_msg"
                                >
                                  {!this.state.isClientNameValid
                                    ? 'Invalid Selection'
                                    : ''}
                                </FormHelperText>
                              </FormGroup>
                            </FormControl>
                          </Grid>
                          {this.state.modelsDetails.length > 0 ? (
                            <Grid item xs={12} sm={12}>
                              <FormControl className="selectbox">
                                <FormGroup className="form-input">
                                  {this.state.brandsDetails.length > 0 && (
                                    <div>
                                      <InputLabel htmlFor="selectLabel">
                                        Select Truck Model
                                      </InputLabel>
                                      <Select
                                        classes={classes}
                                        labelId="model-select-label"
                                        value={this.state.truckModel || ''} // Ensure the value is handled properly
                                        onChange={event =>
                                          this.setState({
                                            truckModel: event.target.value // Update state with selected value
                                          })
                                        }
                                        displayEmpty
                                      >
                                        {this.state.modelsDetails.length > 0 ? (
                                          this.state.modelsDetails.map(
                                            model => (
                                              <MenuItem
                                                key={model.value}
                                                value={model.value}
                                              >
                                                {model.label}
                                              </MenuItem>
                                            )
                                          )
                                        ) : (
                                          <MenuItem disabled>
                                            No options available
                                          </MenuItem>
                                        )}
                                      </Select>
                                    </div>
                                  )}
                                  <FormHelperText
                                    id="name-error-text"
                                    className="Error_msg"
                                  >
                                    {!this.state.isClientNameValid
                                      ? 'Invalid Selection'
                                      : ''}
                                  </FormHelperText>
                                </FormGroup>
                              </FormControl>
                            </Grid>
                          ) : (
                            ''
                          )}
                        </div>
                      ) : (
                        ''
                      )}
                      <Grid item xs={12} sm={12}>
                        {this.state.status !== 2 && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.installStatus}
                                onChange={this.handleChange('installStatus')}
                                value="installStatus"
                                color="primary"
                                disabled={this.state.installStatus}
                              />
                            }
                            label="Installation Completed"
                          />
                        )}
                        {this.state.status === 2 && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.installStatus}
                                onClick={this.handleChange('installStatus')}
                                value="installStatus"
                                color="primary"
                              // disabled={this.state.installStatus}
                              />
                            }
                            label="Installation Completed"
                          />
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12} sm={12}>
                        Device Info:
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup>
                            <TextField
                              id="serialNumber"
                              name="serialNumber"
                              className="textfield"
                              margin="dense"
                              // label="Serial Number"
                              type="text"
                              disabled
                              value={this.state.uniqueDeviceId}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="modelName"
                              name="modelName"
                              className="textfield"
                              margin="dense"
                              label="Model Name"
                              type="text"
                              disabled
                              value={this.state.modelName}
                              onChange={this.handleInputChange('modelName')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="deviceType"
                              name="deviceType"
                              className="textfield"
                              margin="dense"
                              label="Device Type"
                              type="text"
                              disabled
                              value={this.state.deviceType}
                              onChange={this.handleInputChange('deviceType')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="phoneNumber"
                              name="phoneNumber"
                              className="textfield"
                              margin="dense"
                              label="Phone Number"
                              type="text"
                              disabled
                              value={this.state.phoneNumber}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="simProvider"
                              name="simProvider"
                              className="textfield"
                              margin="dense"
                              label="Service Provider"
                              type="text"
                              disabled
                              value={this.state.simProvider}
                              onChange={this.handleInputChange('simProvider')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <FormControl className="selectbox">
                          <FormGroup className="form-input">
                            <TextField
                              id="simNumber"
                              name="simNumber"
                              className="textfield"
                              margin="dense"
                              label="SIM Number"
                              // type="Multi-line"
                              value={this.state.simNumber}
                              disabled
                              onChange={this.handleInputChange('simNumber')}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>
                      {/* new developments */}
                      <Grid container style={{ marginTop: '15px' }}>
                        <Grid item xs={6}>
                          <Button
                            variant="contained"
                            component="span"
                            onClick={() => this.handleGenerate()}
                          >
                            Generate Certificate
                          </Button>
                        </Grid>
                        <Grid item xs={6}>
                          <Button
                            variant="contained"
                            component="span"
                            onClick={() => this.downloadCertificate()}
                          >
                            Download Certificate
                          </Button>
                        </Grid>
                      </Grid>

                      <Grid style={{ marginTop: '15px' }} item xs={6}>
                        <FormControl className="selectbox">
                          <FormGroup>
                            <FormControlLabel
                              control={<Switch />}
                              onChange={() =>
                                this.setState({
                                  addPhoneDetails: !this.state.addPhoneDetails
                                })
                              }
                              checked={this.state.addPhoneDetails}
                              label={'Mobile Details'}
                            />
                          </FormGroup>
                        </FormControl>
                      </Grid>

                      {this.state.addPhoneDetails && (
                        <Grid item xs={12} sm={12}>
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                id="seatLimit"
                                name="seatLimit"
                                className="textfield"
                                margin="dense"
                                label="IMEI  Number"
                                // type="Multi-line"
                                type="number"
                                // error={
                                //   this.state.addPhoneDetails &&
                                //   !this.state.phoneIMEI &&
                                //   !this.state.phoneIMEI.length
                                // }
                                required={this.state.addPhoneDetails}
                                value={this.state.phoneIMEI}
                                onChange={this.handleInputChange('phoneIMEI')}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              />
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      )}
                      {/* end of new developments */}

                      {this.state.vehicleType === 'school bus' && (
                        <Grid item xs={12} sm={12}>
                          <FormControl className="selectbox">
                            <FormGroup className="form-input">
                              <TextField
                                id="seatLimit"
                                name="seatLimit"
                                className="textfield"
                                margin="dense"
                                label="Seat Capacity"
                                // type="text"
                                // type="Multi-line"
                                value={this.state.seatLimit}
                                required
                                onChange={this.handleInputChange('seatLimit')}
                                error={!this.state.isSeatLimitValid}
                                onBlur={this.checkSeatLimitValidity}
                              />
                              <FormHelperText
                                id="name-error-text"
                                className="Error_msg"
                              >
                                {!this.state.isSeatLimitValid
                                  ? 'Invalid Seat Capacity'
                                  : ''}
                              </FormHelperText>
                            </FormGroup>
                          </FormControl>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                <FormGroup className="form-input">
                  <Grid justify="center" container>
                    <Button
                      color="default"
                      variant="outlined"
                      size="medium"
                      margin="normal"
                      className="btn"
                      href="../../VehcileDashboard/Dashboard"
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      size="medium"
                      margin="normal"
                      className="btn"
                      type="button"
                      onClick={this.handleSubmit(this.props.client)}
                      disabled={
                        !(this.state.isVlpnValid &&
                          this.state.vlpn !== '' &&
                          this.state.isSpeedLimitValid &&
                          this.state.isVehicleModelValid &&
                          this.state.isVehicleTypeValid &&
                          this.state.isSpeedSensorValid &&
                          this.state.speedSensorType !== '' &&
                          this.state.speedLimit !== '' &&
                          this.state.vehicleType !== '' &&
                          this.state.vehcleModel !== '' &&
                          this.state.addPhoneDetails
                          ? this.state.phoneIMEI && this.state.phoneIMEI.length
                          : true)
                      }
                    >
                      Submit
                    </Button>
                    <Button
                      color="primary"
                      variant="contained"
                      size="medium"
                      margin="normal"
                      className="btn"
                      onClick={event => this.handleClickOpen()}
                    >
                      {this.state.status === 0 || this.state.status === 3
                        ? 'Activate'
                        : 'De-Activate/Service'}
                    </Button>
                    <Button
                      color="default"
                      variant="contained"
                      size="medium"
                      margin="normal"
                      className="btn"
                      onClick={event => this.handleDecoupleOpen()}
                    >
                      Decouple
                    </Button>
                  </Grid>

                  <Dialog
                    open={this.state.open}
                    keepMounted
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <ChangeVehicleStatus
                      handleClose={this.handleClose}
                      vehicleStatus={this.state.status}
                      uniqueDeviceId={this.state.uniqueDeviceId}
                      history={this.props.history}
                    />
                  </Dialog>
                  <Dialog
                    open={this.state.open3}
                    onClose={
                      this.handleMailClose // keepMounted
                    }
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <div>
                      <DialogTitle id="alert-dialog-title">
                        {'Enter Your Mail Address'}
                      </DialogTitle>
                      <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                          <TextField
                            id="email"
                            name="email"
                            className="textfield"
                            margin="dense"
                            label="Email"
                            onChange={this.handleMailChange}
                            error={!this.state.ismailValid}
                            onBlur={this.checkMail}
                            value={this.state.mail}
                          />
                          <FormHelperText
                            id="name-error-text"
                            className="Error_msg"
                          >
                            {!this.state.ismailValid ? 'Mail is not Valid' : ''}
                          </FormHelperText>
                          {/* <h2>{this.state.PDFLink}</h2> */}
                          <DialogActions>
                            <Button
                              onClick={this.handleMailClose}
                              color="default"
                              variant="contained"
                            >
                              Cancel
                            </Button>
                            <Button
                              type="submit"
                              color="primary"
                              variant="contained"
                              disabled={
                                !(
                                  this.state.mail !== '' &&
                                  this.state.ismailValid
                                )
                              }
                              onClick={() => this.handleSendMail()}
                            >
                              Submit
                            </Button>
                          </DialogActions>
                        </DialogContentText>
                      </DialogContent>
                    </div>
                  </Dialog>
                  <Dialog
                    open={this.state.open2}
                    onClose={this.handleDecoupleClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DecoupleDevices
                      handleClose={this.handleDecoupleClose}
                      vehicleStatus={this.state.status}
                      uniqueDeviceId={this.state.uniqueDeviceId}
                      simId={this.state.simId}
                      clientLoginId={this.state.clientLoginId}
                    />
                  </Dialog>
                  <Dialog
                    open={this.state.swapOpen}
                    keepMounted
                    onClose={this.handleSwapClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <SwapClient
                      handleClose={this.handleSwapClose}
                      clientLoginId={this.state.clientLoginId}
                      clientName={this.state.clientName}
                      vlpn={this.state.vlpn}
                    />
                  </Dialog>
                  <Dialog
                    open={this.state.deleteOpen}
                    keepMounted
                    onClose={this.handleDeleteClose}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                  >
                    <DeleteVehicle
                      handleClose={this.handleDeleteClose}
                      uniqueDeviceId={this.state.uniqueDeviceId}
                      handleSucessDeleteClose={this.handleSucessDeleteClose}
                    />
                  </Dialog>
                </FormGroup>
              </div>
            </form>
            {/* </ItemCard> */}
          </Grid>
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(
  withApollo(withSharedSnackbar(VehicleRegistration))
)



// WEBPACK FOOTER //
// ./src/components/Modules/VehicleRegistartion/VehicleEdit/index.jsx